// Phone-number formatting utility.
//
// Historically this file also exported handleBeforeInput / handleKeyDown /
// handlePaste / cursorPosToDigitIndex — a hand-rolled masked-input
// implementation. Those were retired in favor of `react-imask` via the
// shared `PhoneMaskInput` component. The remaining `formatPhone` helper is
// kept because it's still used for *display-only* formatting outside an
// input context (e.g., error messages in ProfileWizard).

const numberSeparators = '() .-'
export const formatPhone = (v: string, isDeleting: boolean = false, pos = 0) => {
    if (!v) {
        return v
    }
    console.info(v)
    let output = ''
    for (var i = 0; i < v.length; i++) {
        const digits = output.replace(/\D/g, "")
        if (output.length >= 14) {
            break
        }
        const ch = v[i]
        const suffix = v.slice(i + 1)
        if (output.length === 0) {
            if (/\d/.test(ch)) {
                output = `(${ch}`
            } else if (numberSeparators.includes(ch)) {
                output = '('
            }
            continue
        }

        if (output.length === 3) {
            if (/\d/.test(ch)) {
                output = `${output}${ch}${(!isDeleting || i < (v.length - 1)) ? ")" : ""}`
            }
            continue
        }
        if (output.length === 5) {
            if (numberSeparators.includes(ch)) {
                output = `${output}${(!isDeleting || i < (v.length - 1)) ? " " : ""}`
            } else if (/\d/.test(ch)) {
                output = output + ` ${ch}`
            }
            continue
        }
        if (output.length === 9) {
            if (numberSeparators.includes(ch)) {
                output = `${output}${(!isDeleting || i < (v.length - 1)) ? "-" : ""}`
            } else if (/\d/.test(ch)) {
                output = output + `-${ch}`
            }
            continue
        }
        if (/\d/.test(ch)) {
            output = output + ch
            continue
        }
    }
    return output
}
